import { createContext, useMemo } from "react";
import type { LocalizationContextProviderProps, LocalizationContextProps } from "./types";

export const LocalizationContext = createContext<LocalizationContextProps>({
  language: "en",
  translations: {},
});

export const LocalizationContextProvider = ({ language, translations, children }: LocalizationContextProviderProps) => {
  const localizationContextProviderValue = useMemo(
    () => ({
      language,
      translations,
    }),
    [language, translations]
  );

  return (
    <LocalizationContext.Provider value={localizationContextProviderValue}>{children}</LocalizationContext.Provider>
  );
};
